import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Replaces or merges array's elements in-place from source if they already
 * exist in target. Otherwise, appends to end of the array.
 */
export var mergeArray = function mergeArray(target, source) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$key = _ref.key,
      key = _ref$key === void 0 ? 'name' : _ref$key;

  // Replace items with in-place. Keeps position from original array.
  var updatedTarget = target.map(function (targetItem) {
    var foundMatch;

    if (_typeof(targetItem) !== 'object') {
      // Simple values:
      foundMatch = source.find(function (sourceItem) {
        return sourceItem === targetItem;
      });
      return foundMatch || targetItem;
    } else {
      // Objects:
      foundMatch = source.find(function (sourceItem) {
        return sourceItem[key] === targetItem[key];
      });
      return foundMatch || targetItem;
    }
  }); // Caching ids for easier lookup below

  var updatedTargetKeys = new Set(updatedTarget.map(function (item) {
    return item[key] || item;
  }));
  return [].concat(_toConsumableArray(updatedTarget), _toConsumableArray(source.filter(function (item) {
    return !updatedTargetKeys.has(item[key] || item);
  })));
};
/**
 * Creates a copy of the specified Builder custom component model with overrides
 * and excluded options and/or inputs. Accepts an object param as follows:
 *   - {Object} `base`          Builder custom component base model.
 *   - {Object} `overrides`     Component model fields and/or inputs to use as override.
 *   - {Array}  `excludes`      Component model fields to exclude from the base model.
 *   - {Array}  `excludeInputs` Objects in `inputs` field to exclude from the base model by "name" prop.
 *   - {Boolean} `shouldDeepMerge` Whether to deep merge objects and arrays.
 */

export function overrideBuilderModel(_ref2) {
  var _ref2$base = _ref2.base,
      base = _ref2$base === void 0 ? {} : _ref2$base,
      _ref2$overrides = _ref2.overrides,
      overrides = _ref2$overrides === void 0 ? {} : _ref2$overrides,
      excludes = _ref2.excludes,
      excludeInputs = _ref2.excludeInputs;

  // Merge top-level fields first:
  var model = _objectSpread(_objectSpread({}, base), overrides); // Merge `inputs` array of objects


  if (Array.isArray(overrides.inputs)) {
    model.inputs = mergeArray(base.inputs, overrides.inputs);
  } // Remove excluded fields:


  if (excludes !== null && excludes !== void 0 && excludes.length) {
    new Set(excludes).forEach(function (value) {
      delete model[value];
    });
  } // Remove excluded `inputs` fields by objects' "name" field


  if (Array.isArray(excludeInputs)) {
    var excludeInputsSet = new Set(excludeInputs);
    model.inputs = model.inputs.filter(function (item) {
      return !excludeInputsSet.has(item.name);
    });
  }

  return model;
}